/* istanbul ignore file */ /* not actual functions */

import type { SG_GraphCacheTypes } from '@sg/graphql-schema';

type GraphCacheConfig = SG_GraphCacheTypes.GraphCacheConfig;

type GraphCacheKeys = GraphCacheConfig['keys'];

export const keys: GraphCacheKeys = {
  // No Identifiers
  AvailableWantedTime: () => null,
  EstimateRange: () => null,
  GiftCardDeliveryDetail: () => null,
  InStoreOrdersResponse: () => null,
  IngredientModification: () => null,
  IngredientModifications: () => null,
  IngredientModificationKind: () => null,
  InvalidInput: () => null,
  HasUnseenChallenges: () => null,
  Ledger: () => null,
  LedgerItem: () => null,
  Location: () => null,
  LoyaltyAccessToken: () => null,
  Menu: () => null,
  NoValidRestaurants: () => null,
  OrderStatus: () => null,
  OrdersResponseSuccess: () => null,
  Pagination: () => null,
  PointHistoryForUserSuccess: () => null,
  DeliveryOrderDetail: () => null,
  RestaurantHours: () => null,
  RestaurantStoreHours: () => null,
  Vendor: () => null,
  CustomerPass: () => null,
  UserNotificationPreferences: () => null,
  UserPointsStatus: () => null,
  ChatToken: () => null,

  Session: (data: any) => data.csrf ?? null,
  Restaurant: (data: any) => data.slug ?? data.id ?? null,

  // Menu products are restaurant-aware, but cart/reorder queries can return the
  // same product ID without menu fields. Keep menu products separate so those
  // smaller projections cannot make menu content data unreadable.
  Product: (data: any) =>
    data.restaurantId && data.id ? `${data.restaurantId}:${data.id}` : (data.id ?? null),

  Asset: (data: any) => data.url ?? null,
  LoyaltyProfile: (data: any) => data.customerId ?? null,
  GiftCardBalance: (data: any) => data.customerId ?? null,
  GiftCardPurchaseHistory: (data: any) => data.customerId ?? null,
  CanCancel: (data: any) => (data.orderId ? `${data.orderId}` : null),
};
